import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
export const AccountSwitcherDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AccountSwitcher"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"member"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}}},{"kind":"Argument","name":{"kind":"Name","value":"waitOn"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"MemberHeader"}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"avatarSource"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"initials"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"isAaMastered"}},{"kind":"Field","name":{"kind":"Name","value":"oneTimeMessagesDismissed"}},{"kind":"Field","name":{"kind":"Name","value":"nonPublic"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"initials"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"AccountSwitcher","document":AccountSwitcherDocument}} as const;
export type AccountSwitcherQueryVariables = Types.Exact<{
  memberId: Types.Scalars['ID'];
}>;


export type AccountSwitcherQuery = (
  { __typename: 'Query' }
  & { member?: Types.Maybe<(
    { __typename: 'Member' }
    & Pick<Types.Member, 'avatarSource' | 'avatarUrl' | 'email' | 'fullName' | 'id' | 'initials' | 'username' | 'isAaMastered' | 'oneTimeMessagesDismissed'>
    & { nonPublic?: Types.Maybe<(
      { __typename: 'Member_NonPublic' }
      & Pick<Types.Member_NonPublic, 'avatarUrl' | 'initials' | 'fullName'>
    )> }
  )> }
);




/**
 * __useAccountSwitcherQuery__
 *
 * To run a query within a React component, call `useAccountSwitcherQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountSwitcherQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountSwitcherQuery({
 *   variables: {
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function useAccountSwitcherQuery(baseOptions: Apollo.QueryHookOptions<AccountSwitcherQuery, AccountSwitcherQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountSwitcherQuery, AccountSwitcherQueryVariables>(AccountSwitcherDocument, options);
      }
export function useAccountSwitcherLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountSwitcherQuery, AccountSwitcherQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountSwitcherQuery, AccountSwitcherQueryVariables>(AccountSwitcherDocument, options);
        }
export type AccountSwitcherQueryHookResult = ReturnType<typeof useAccountSwitcherQuery>;
export type AccountSwitcherLazyQueryHookResult = ReturnType<typeof useAccountSwitcherLazyQuery>;
export type AccountSwitcherQueryResult = Apollo.QueryResult<AccountSwitcherQuery, AccountSwitcherQueryVariables>;